
const Host = "https://nabni.hec.to/backend/public/api"
// const Host = "http://127.0.0.1:8000/api"


export const api_Routes = {
    auth: {
        login: `${Host}/auth`,
        register: `${Host}/auth`,
        view:`${Host}/auth/users`,
        permissions :(id)=>(`${Host}/permissions/byRole/${id}`),
    },
   
    role: {
        view: `${Host}/roles`,
        add: `${Host}/roles`,
        bulkDelete: (id) => (`${Host}/roles/${id}`),
        getOne: (id) => (`${Host}/roles/${id}`),
        update: (id) => (`${Host}/roles/${id}`),
    },
    permission: {
        view: `${Host}/permissions`,
        add: `${Host}/permissions/assign`,
        bulkDelete: (id) => (`${Host}/permissions/${id}`),
        getByRole: (id) => (`${Host}/permissions/byRole/${id}`),
        getOne: (id) => (`${Host}/permissions/${id}`),
        update: (id) => (`${Host}/permissions/${id}`),
    },

}
